import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { assert } from 'ts-essentials';
import { Sentence } from './models/sentence';
import { ConsentService } from './services/consent.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class ConsentComponent implements OnInit {
  cguLink!: string;
  openBankingObjectivesSentences: Sentence[] = [];

  selectedSentence!: Sentence | null;
  conditionAccepted = false;
  isConditionsOpen = false;
  isCancelPopinOpen = false;

  constructor(
    private consentService: ConsentService,
    private storeService: StoreService,
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'CONSENT' });

    const token = this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN');

    this.consentService.getTerms(token).subscribe((terms) => {
      this.openBankingObjectivesSentences = JSON.parse(terms.jsonFile);
      this.cguLink = terms.pdfURI;
      this.storeService.setVariable('CGU_VERSION', terms.cguVersion);
      this.storeService.setVariable('TERMS_VERSION', terms.termsVersion);
    });
  }

  openCancelPopin() {
    this.tracker.trackClick({ click: frenchi18n.common_refuse, taggingPage: 'CONSENT' });

    this.isCancelPopinOpen = true;
  }

  closeCancelPopin() {
    this.isCancelPopinOpen = false;
  }

  openSentence(sentenceIndex: number) {
    const sentence = this.openBankingObjectivesSentences[sentenceIndex];
    assert(sentence != null, `entence should be defined for index ${sentenceIndex}`);
    this.selectedSentence = sentence;
    this.tracker.trackClick({ click: this.selectedSentence.title, taggingPage: 'CONSENT' });
  }

  closeSentence() {
    this.selectedSentence = null;
  }

  openConditions() {
    this.tracker.trackClick({
      click: frenchi18n.information_details_text2,
      taggingPage: 'CONSENT',
    });

    this.isConditionsOpen = true;
  }

  closeConditions() {
    this.isConditionsOpen = false;
  }

  onAccepted() {
    this.tracker.trackClick({ click: frenchi18n.common_accept, taggingPage: 'CONSENT' });

    this.consentService
      .sendConsent({
        userToken: this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN'),
        userId: this.storeService.getVariableOrThrow('USER_ID'),
        hasConsented: true,
        cguVersion: this.storeService.getVariableOrThrow('CGU_VERSION'),
        termsVersion: this.storeService.getVariableOrThrow('TERMS_VERSION'),
      })
      .subscribe((_) => this.processEventService.push(ProcessEventFactory.SpawnConsentEvent()));
  }

  openCGU(event: Event) {
    this.tracker.trackClick({ click: frenchi18n.information_check_more, taggingPage: 'CONSENT' });

    event.preventDefault();
    event.stopImmediatePropagation();
    window.open(this.cguLink, '_blank');
  }
}
